// T22.201: media-browser data split out of constants/segmentTools.js so the
// Media Browser (reachable from the always-loaded Profile menu -> Themes popup)
// does not import segmentTools, which drags the whole SegmentBuilder/Froala
// tree into main.js. segmentTools re-exports these for existing importers.

export const searchEngines = {
  image: [
    { id: 0, key: 1, title: "Images", items: [] },
    { id: 1, key: 2, title: "Gifs", items: [] },
  ],
  images: [
    { id: 0, key: 1, title: "Images", items: [] },
    { id: 1, key: 2, title: "Gifs", items: [] },
  ],
  // gordon-0915-video-block-media-pane-pixabay-embed-first-record-tier: the
  // Video Browse tab was Youtube-only (key 1), and its live scraper
  // (_scrape_youtube_videos, no official API) is currently returning zero
  // results for EVERY query ("cat", "dog", "music" — not just "Architecture"),
  // measured live against app-dev's /api/v2/wheel/get-media/?type=2&source=1.
  // BE already has a working Pixabay video source (VideoSource.PIXABAY=3,
  // yuga_wheel/api/v2/viewsets/wheel/actions/get_media.py) that returns real
  // results (verified live for "Architecture") but was unreachable from the
  // FE — see yuga_wheel/tests/test_get_media_video_source_contract.py's own
  // "unreachable from the current FE" note.
  //
  // FOLLOW-UP (same day): a first cut of this fix added Pixabay as a
  // second, manually-selected engine and left Youtube as the DEFAULT. That
  // does not actually fix Gordon's reported repro — his exact steps
  // (open Video Browse, search "Architecture", do nothing else) still hit
  // the dead Youtube scraper by default and still show "No results found".
  // Pixabay must be the DEFAULT/first entry so the tab that already shows
  // the Pixabay logo/branding actually searches Pixabay out of the box.
  // Youtube stays reachable as a manual fallback via the dropdown (still a
  // real key=1 -> VideoSource.YOUTUBE route per
  // test_get_media_video_source_contract.py, which only pins the BE's
  // source=1 routing and does not care which entry the FE defaults to).
  video: [
    { id: 0, key: 3, title: "Pixabay", items: [] },
    { id: 1, key: 1, title: "Youtube", items: [] },
  ],
};

export const initialKeywords = [
  { id: 0, title: "Abstract" },
  { id: 1, title: "Animal" },
  { id: 2, title: "Architecture" },
  { id: 3, title: "Art" },
  { id: 4, title: "Business" },
  { id: 5, title: "Colorful" },
  { id: 6, title: "Food" },
  { id: 7, title: "Interior" },
  { id: 8, title: "Minimal" },
  { id: 9, title: "Nature" },
  { id: 10, title: "Plant" },
  { id: 11, title: "Portrait" },
  { id: 12, title: "Space" },
  { id: 13, title: "Technology" },
  { id: 14, title: "Texture" },
  { id: 15, title: "Wallpaper" },
];

export const MEDIA_TYPE = {
  image: 1,
  images: 1,
  video: 2,
  gif: 3,
};
